import sileo from 'sileo';

const Notifications = new sileo.Model('hqzen', 'notifications');

const actions = {
    fetchNotifications(context, filters) {
        return Notifications.objects.filter(filters);
    },

    updateNotifications(context, data) {
        const form = new FormData();
        form.append('read', data.read);

        const filters = {};
        if (data.ids || data.ids?.length) {
            filters['pk__in'] = data.ids;
        }

        return Notifications.objects.update(filters, form);
    },
};

export default {
	namespaced: true,
	actions
};
